/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resend_Invitation_SuccessInputs */

const fr_resend_invitation_success = /** @type {(inputs: Resend_Invitation_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation renvoyée`)
};

/**

* @param {Resend_Invitation_SuccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const resend_invitation_success = /** @type {((inputs?: Resend_Invitation_SuccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resend_Invitation_SuccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_resend_invitation_success(inputs)
});